import type { ComponentPropsWithoutRef, ReactNode } from 'react';

type Variant = 'primary' | 'ghost' | 'accent';
type Size = 'sm' | 'md' | 'lg';

type CommonProps = {
  variant?: Variant;
  size?: Size;
  children: ReactNode;
  className?: string;
};

const buildClass = ({ variant = 'primary', size = 'md', className }: CommonProps) => {
  const classes = ['pixel-btn'];
  if (variant === 'ghost') classes.push('pixel-btn--ghost');
  if (variant === 'accent') classes.push('pixel-btn--accent');
  if (size === 'sm') classes.push('pixel-btn--sm');
  if (size === 'lg') classes.push('pixel-btn--lg');
  if (className) classes.push(className);
  return classes.join(' ');
};

type ButtonProps = CommonProps & Omit<ComponentPropsWithoutRef<'button'>, 'className' | 'children'>;

export const PixelButton = ({
  variant,
  size,
  className,
  children,
  type = 'button',
  ...rest
}: ButtonProps) => (
  <button type={type} className={buildClass({ variant, size, className, children })} {...rest}>
    {children}
  </button>
);

type LinkProps = CommonProps & Omit<ComponentPropsWithoutRef<'a'>, 'className' | 'children'>;

export const PixelLink = ({ variant, size, className, children, ...rest }: LinkProps) => (
  <a className={buildClass({ variant, size, className, children })} {...rest}>
    {children}
  </a>
);
